module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am464-3afb4e0bf8204fcbe65c7b20d2262750.jpg";